/**
 * Utility function to extract and validate lang parameter from URL
 * Can be used both in React components (via hooks) and in module-level code (i18n)
 */
export const getLangFromUrl = (availableLanguages: string[]): string | null => {
	const urlParams = new URLSearchParams(window.location.search);
	const urlLang = urlParams.get('lang');
	
	if (urlLang && availableLanguages.includes(urlLang)) {
		return urlLang;
	}
	
	return null;
};
